// src/app/auth/token.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators'
import { Router } from '@angular/router';
import { ModuleConfigService as ConfigService } from 'src/app/shared/services/config.service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router,
    private configService: ConfigService
  ) { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => { if (this.configService.env == 'dev' || this.configService.env == 'test') console.log(event); }, err => {
        if (err instanceof HttpErrorResponse && (err.status === 401)) {
          if (this.configService.env == 'dev' || this.configService.env == 'test') {
            console.log(err);
          }
          // Now we caught error, we can put logic here....
          // For some reason HttpInterceptors cannot depend on sevices that use HttpClient, causes cyclic dependency error
          //this.router.navigate(['logout']);
        }
      })
    )
  }
}
